function ZKON() {
    window.Buffer = window.Buffer || require("buffer").Buffer; 

    const hexEncode = (string) => {
        var hex, i;
    
        var result = "";
        for (i=0; i<string.length; i++) {
            hex = string.charCodeAt(i).toString(16);
            result += hex;
        }
    
        return result
    }
    
    const randomBytes = (count) => {
        const result = Array(count);
          for (let i = 0; i < count; ++i) {
            result[i] = Math.floor(256 * Math.random());
        }
        return result;
    }

    const xor = (hex1, hex2) => {
        const buf1 = Buffer.from(hex1, 'hex');
        const buf2 = Buffer.from(hex2, 'hex');
        const bufResult = buf1.map((b, i) => b ^ buf2[i]);
        return bufResult.toString('hex');
    }

    const toHexString = (byteArray) => {
        return Array.from(byteArray, function(byte) {
          return ('0' + (byte & 0xFF).toString(16)).slice(-2);
        }).join('')
    }

    return {
        convertKeyIntoShards: (key) => {
            let splitG = toHexString(randomBytes(64));
            let splitE = toHexString(randomBytes(64));
            const keyG = xor(splitG, splitE) //Computed key share of Garbler
            const keyE = xor(hexEncode(key).padStart(128, '0'), keyG) //Computed key share of Evaluator 
            return [keyG, keyE];
        }
    }
}

export default ZKON;